module.exports = new __parcel__URL__("logo_med_tekst.8add659b.svg").toString();